import * as css from './Close.css';

function Close({className,onClick,icon = ""}) {
    return (
        <css.Close className={'close '+ (className&& className)}  onClick={onClick}  data-cy ={`closeCircle${icon && `-${icon}`}`}/>
    );
}

export default Close;
